import { render, staticRenderFns } from "./categoryProducts.vue?vue&type=template&id=05d9985c&scoped=true&"
import script from "./categoryProducts.vue?vue&type=script&lang=js&"
export * from "./categoryProducts.vue?vue&type=script&lang=js&"
import style0 from "./categoryProducts.vue?vue&type=style&index=0&id=05d9985c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d9985c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05d9985c')) {
      api.createRecord('05d9985c', component.options)
    } else {
      api.reload('05d9985c', component.options)
    }
    module.hot.accept("./categoryProducts.vue?vue&type=template&id=05d9985c&scoped=true&", function () {
      api.rerender('05d9985c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/Selected-products/categoryProducts.vue"
export default component.exports